module.exports = __webpack_public_path__ + "static/boardgame-35ec7277c3a209cef5ec610ade4fdf85.jpg";